
import React from 'react';
import { Trash2, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface StageActionsProps {
  onEdit: () => void;
  onDelete: () => void;
  isComplete?: boolean;
}

const StageActions: React.FC<StageActionsProps> = ({ onEdit, onDelete, isComplete = false }) => {
  return (
    <div className="flex items-center justify-between w-full border-t pt-2">
      <CheckCircle2 
        className={`h-4 w-4 ${isComplete ? 'text-emerald-500' : 'text-gray-300'}`} 
        aria-label={isComplete ? "Stage complete" : "Stage incomplete"}
      />
      <Button variant="ghost" size="icon" onClick={onDelete} className="h-7 w-7 text-destructive">
        <Trash2 className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
};

export default StageActions;
